document.addEventListener('DOMContentLoaded', function () {

  function getWishlist() {
    try {
      var stored = JSON.parse(localStorage.getItem('wishlist') || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem('wishlist', JSON.stringify(list));
    localStorage.setItem('user_wishlist_cnt', list.length);
    updateCounter();
  }

  // Always derive the badge from the actual saved list, and run this on
  // every page load — not just pages that happen to have heart buttons on
  // them — so the header count is correct everywhere (cart, blog, home, etc).
  function updateCounter() {
    var count = getWishlist().length;
    $('.wishlist-counter').text(count > 0 ? count : '').css('display', count > 0 ? '' : 'none');
  }

  // Mark any heart buttons on the current page as active if their product
  // is already wishlisted, so the icon reflects saved state on page load.
  function markActiveButtons() {
    var wishlist = getWishlist();
    $('.wishlist-custom-action').each(function () {
      var handle = $(this).attr('data-handle');
      if ($.inArray(handle, wishlist) >= 0) {
        $(this).addClass('active-wishlist').removeClass('wishlist-custom-action');
      }
    });
  }

  markActiveButtons();
  updateCounter();

  jQuery(document).on('click', '.wishlist-custom-action', function (e) {
    e.preventDefault();
    var value = $(this).attr('data-handle');
    var wishlist = getWishlist();
    if ($.inArray(value, wishlist) === -1) {
      wishlist.push(value);
    }
    saveWishlist(wishlist);

    $(this).removeClass('wishlist-custom-action').addClass('active-wishlist');
    $(".wishlist[data-handle='" + value + "']")
      .removeClass('wishlist-custom-action')
      .addClass('active-wishlist');
  });

  jQuery(document).on('click', '.active-wishlist', function (e) {
    e.preventDefault();
    var toDelete = $(this).attr('data-handle');
    var wishlist = getWishlist().filter(function (handle) { return handle !== toDelete; });
    saveWishlist(wishlist);

    $(this).removeClass('active-wishlist').addClass('wishlist-custom-action');
    $(".wishlist[data-handle='" + toDelete + "']")
      .removeClass('active-wishlist')
      .addClass('wishlist-custom-action');
  });
});